export const stats: Record<string, string> = {
	stats_sectionCombat: "Combate",
	stats_sectionExploration: "Exploração",
	stats_sectionItems: "Itens",
	stats_sectionSurvival: "Sobrevivência",
	stats_sectionHighlights: "Destaques",
	stats_labelMobsKilled: "Inimigos eliminados",
	stats_labelDamageReceived: "Dano recebido",
	stats_labelShotsFired: "Tiros disparados",
	stats_labelTurnsElapsed: "Turnos",
	stats_labelTilesWalked: "Passos dados",
	stats_labelLevelsVisited: "Níveis visitados",
	stats_labelFavoriteLevel: "Nível favorito",
	stats_labelAmmoCollected: "Munição coletada",
	stats_labelContainersOpened: "Caixas abertas",
	stats_labelObstaclesDestroyed: "Obstáculos destruídos",
	stats_labelLowestHp: "Menor HP",
	stats_labelHealingReceived: "Cura recebida",
	stats_labelCauseOfDeath: "Causa da morte",
	stats_labelMostUsedWeapon: "Arma mais usada",
	stats_labelMostLethalWeapon: "Mais letal",
	stats_labelGameStarted: "Jogo iniciado",
	stats_labelRunDuration: "Duração da partida",
};
